/*!
 * Custom Product Gallery (Swiper-based, isolated)
 * --------------------------------------------------------------------------
 * - One pair of Swipers per [data-gallery] element (no global selectors).
 * - Independent of the legacy Evestar gallery (.gallery-top / .gallery-thumbs
 *   / .product-imageslide / .product-thumbnail).
 * - Re-initialises safely on shopify:section:load, bfcache restore, and when
 *   nodes are injected (quick-view popup, variant re-render, etc.).
 * - Syncs to variant-selected media via the 'custom-gallery:variant-change'
 *   CustomEvent dispatched by productSliderupdate() in assets/global.js.
 */
(function () {
  'use strict';

  var INIT_FLAG = 'customGalleryInit';

  function destroyIfNeeded(el) {
    if (el && el.swiper) {
      try { el.swiper.destroy(true, true); } catch (e) { /* no-op */ }
    }
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset[INIT_FLAG] === '1') return;
    if (typeof window.Swiper !== 'function') return;

    var mainEl = gallery.querySelector('.main-slider');
    var thumbEl = gallery.querySelector('.thumb-slider');
    var nextBtn = gallery.querySelector('.swiper-button-next');
    var prevBtn = gallery.querySelector('.swiper-button-prev');
    var isMobile = false;
    try {
      isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    } catch (e) { /* no-op */ }

    if (!mainEl) return;

    destroyIfNeeded(mainEl);
    destroyIfNeeded(thumbEl);

    var thumbSwiper = null;
    if (thumbEl && !isMobile) {
      thumbSwiper = new window.Swiper(thumbEl, {
        slidesPerView: 3,
        spaceBetween: 10,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        observer: true,
        observeParents: true
      });
    }

    const mainSwiper = new window.Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      observer: true,
      observeParents: true,

      navigation: {
        nextEl: nextBtn || null,
        prevEl: prevBtn || null
      },

      thumbs: thumbSwiper ? { swiper: thumbSwiper } : undefined,

      on: {
        init: function () {
          const activeSlide = this.slides[this.activeIndex];
          const activeVideo = activeSlide.querySelector(".product-video");

          if (activeVideo) {
            activeVideo.play().catch(() => {});
          }
        },

        slideChangeTransitionEnd: function () {
          console.log("slide changed");

          gallery.querySelectorAll(".product-video").forEach((video) => {
            video.pause();
            video.currentTime = 0;
          });

          const activeSlide = this.slides[this.activeIndex];

          console.log("active slide", activeSlide);

          const activeVideo = activeSlide.querySelector(".product-video");

          console.log("active video", activeVideo);

          if (activeVideo) {
            activeVideo.play().then(() => {
              console.log("video playing");
            }).catch((err) => {
              console.log("play failed", err);
            });
          }
        }
      }
    });

    gallery.dataset[INIT_FLAG] = '1';
  }

  function autoplayActiveVideo(swiper) {
  if (!swiper || !swiper.slides) return;

  swiper.slides.forEach(function (slide) {
    const video = slide.querySelector('video');

    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });

  const activeSlide = swiper.slides[swiper.activeIndex];

  if (!activeSlide) return;

  const activeVideo = activeSlide.querySelector('video');

  if (!activeVideo) return;

  activeVideo.muted = true;
  activeVideo.setAttribute('muted', '');
  activeVideo.setAttribute('playsinline', '');
  activeVideo.setAttribute('autoplay', '');

  const playPromise = activeVideo.play();

  if (playPromise !== undefined) {
    playPromise.catch(function (err) {
      console.log('Video autoplay blocked:', err);
    });
  }
}

  function initAll(scope) {
    var root = (scope && typeof scope.querySelectorAll === 'function') ? scope : document;
    var galleries = root.querySelectorAll('[data-gallery]');
    if (!galleries.length) return;

    if (typeof window.Swiper === 'function') {
      galleries.forEach(function (g) { initGallery(g); });
      return;
    }

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof window.Swiper === 'function') {
        clearInterval(timer);
        galleries.forEach(function (g) { initGallery(g); });
      } else if (attempts >= 80) {
        clearInterval(timer);
      }
    }, 100);
  }

  // Expose for the quick-view flow in assets/global.js which calls this
  // after injecting a product detail partial into the DOM.
  window.initCustomProductGalleries = initAll;

  function onReady() { initAll(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  // Theme editor / section re-render.
  document.addEventListener('shopify:section:load', function (event) {
    var target = (event && event.target) || document;
    try {
      target.querySelectorAll('[data-gallery]').forEach(function (g) {
        delete g.dataset[INIT_FLAG];
      });
    } catch (e) { /* no-op */ }
    initAll(target);
  });

  // bfcache restore (back / forward navigation).
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.querySelectorAll('[data-gallery]').forEach(function (g) {
        delete g.dataset[INIT_FLAG];
      });
      initAll(document);
    }
  });

  // Variant change sync — emitted by productSliderupdate() in global.js.
  document.addEventListener('custom-gallery:variant-change', function (evt) {
    var detail = (evt && evt.detail) || {};
    var sectionId = detail.sectionId;
    var variantImageId = detail.variantImageId;
    if (!sectionId || !variantImageId) return;

    var section = document.getElementById(sectionId);
    if (!section) return;

    var gallery = section.querySelector('[data-gallery]');
    if (!gallery) return;

    var mainEl = gallery.querySelector('.main-slider');
    if (!mainEl || !mainEl.swiper) return;

    var slides = mainEl.querySelectorAll('.swiper-slide');
    var index = -1;
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].getAttribute('data-mediaid')) === String(variantImageId)) {
        index = i;
        break;
      }
    }
    if (index >= 0) {
      mainEl.swiper.slideTo(index, 300, false);
    }
  });
})();